import * as React from "react";
import { Button, Modal } from "react-bootstrap";
import { List, ListItem } from "material-ui/List";
import Subheader from 'material-ui/Subheader';
import Avatar from 'material-ui/Avatar';
import DownloadFile from 'material-ui/svg-icons/file/cloud-download';
import Divider from 'material-ui/Divider';
import icoXLS from "../../../../../../assets/img/ico-xls.png";
import { TipoReporteGlosa } from "../modelo/TipoReporteGlosa";

export default class ModalXLSReporteGlosas extends React.Component<ModalXLSReporteGlosasProps, any> {

    render() {
        return (
            <div>
                <Modal show={this.props.verModalXLS} onHide={this.props.closeModalXLS}>
                    <Modal.Header>
                        <Modal.Title>Exportar XLS - Reporte General de Glosas SAT por Servicio</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Existen dos reportes de glosas para exportar entre las fechas seleccionadas,
                        ambos reportes contienen todos los servicios gestionables en SAT.
                        <br />
                        <br />
                        Selecciona el reporte que deseas exportar, para así iniciar la descarga.
                        <List>
                            <Subheader>Listado de reportes de glosas SAT por servicio</Subheader>
                            {this.listaReportesXLS()}
                        </List>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className={"btns btns-secondary"} onClick={this.props.closeModalXLS}>Cerrar</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }

    listaReportesXLS() {
        return (
            <List>
                <div key={0}>
                    <Divider />
                    <ListItem
                        primaryText={"Descargar reporte general de glosas"}
                        leftAvatar={<Avatar src={icoXLS} size={40} />}
                        rightIcon={<DownloadFile />}
                        onClick={this.props.generarXLS.bind(this, TipoReporteGlosa.REPORTE_EXCEL_GENERAL)}
                    />
                </div>
                <div key={1}>
                    <Divider />
                    <ListItem
                        primaryText={"Descargar reporte detalle de glosas"}
                        leftAvatar={<Avatar src={icoXLS} size={40} />}
                        rightIcon={<DownloadFile />}
                        onClick={this.props.generarXLS.bind(this, TipoReporteGlosa.REPORTE_EXCEL_DETALLE)}
                    />
                </div>
            </List>
        );
    }
}

interface ModalXLSReporteGlosasProps {
    verModalXLS: boolean,
    closeModalXLS: () => void;
    generarXLS: (tipo: number) => void;
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/reporte_glosas/componentes/ModalXLSReporteGlosas.tsx